import React, { useCallback } from 'react'
import { I18n, hooks } from '@front/volcanion'

import { Typography, Grid, Box, Button } from '@mui/material'
import { ModelAutocompleteField, DateField } from '@front/squirtle'

import Callbacks from './callbacks'

const Row1 = () => {
  const autocompleteMutatorStaff = useCallback(Callbacks.autocompleteMutatorStaff(), [])
  const autocompleteMutatorClient = useCallback(Callbacks.autocompleteMutatorClient(), [])
  const autocompleteMutatorDriver = useCallback(Callbacks.autocompleteMutatorDriver(), [])
  const staffMutator = useCallback(Callbacks.staffMutator(), [])
  const clientMutator = useCallback(Callbacks.clientMutator(), [])
  const driverMutator = useCallback(Callbacks.driverMutator(), [])
  return (
    <Grid container spacing={1}>
      <Grid size="grow">
        <ModelAutocompleteField
          name='operator'
          label={I18n.t('operator', { count: 1 })}
          model_name='user'
          searchMode='search'
          searchQuery='='
          autocompleteMutator={autocompleteMutatorStaff}
          labelKeys={['label']}
          loadOnFocus={false}
          config={{
            forced_filter: { staffinfo: { '!': null } },
            populate: ['info', 'auth'],
            mutator: staffMutator
          }}
        />
      </Grid>
      <Grid size="grow">
        <ModelAutocompleteField
          name='client'
          label={I18n.t('user.search_multiple')}
          model_name='user'
          searchMode='search'
          searchQuery='='
          autocompleteMutator={autocompleteMutatorClient}
          labelKeys={['label']}
          loadOnFocus={false}
          config={{
            forced_filter: { customerinfo: { '!': null } },
            populate: ['info', 'customerinfo'],
            mutator: clientMutator
          }}
        />
      </Grid>
      <Grid size="grow">
        <ModelAutocompleteField
          name='driver'
          label={I18n.t('driver.search_multiple')}
          model_name='user'
          searchMode='search'
          searchQuery='='
          autocompleteMutator={autocompleteMutatorDriver}
          labelKeys={['label']}
          loadOnFocus={false}
          config={{
            forced_filter: { driverinfo: { '!': null } },
            populate: ['info', 'customerinfo'],
            mutator: driverMutator
          }}
        />
      </Grid>
    </Grid>
  );
}

const Row2 = () => {
  const autocompleteMutatorCompany = useCallback(Callbacks.autocompleteMutatorCompany(), [])
  const autocompleteMutatorGroup = useCallback(Callbacks.autocompleteMutatorGroup(), [])
  const companyMutator = useCallback(Callbacks.companyMutator(), [])
  const groupMutator = useCallback(Callbacks.groupMutator(), [])
  return (
    <Grid container spacing={1}>
      <Grid size="grow">
        <ModelAutocompleteField
          name='company'
          label={I18n.t('company.name_client_id')}
          model_name='company'
          searchMode='search'
          searchQuery='startsWith'
          autocompleteMutator={autocompleteMutatorCompany}
          labelKeys={['label']}
          loadOnFocus={false}
          config={{ mutator: companyMutator }}
        />
      </Grid>
      <Grid size="grow">
        <ModelAutocompleteField
          name='vehicle'
          label={I18n.t('vehicle.label', { count: 1 })}
          model_name='vehicle'
          searchMode='search'
          searchQuery='startsWith'
          autocompleteKey='info.plaque'
          config={{ populate: ['info'] }}
          labelKeys={['info.plaque']}
          loadOnFocus={false}
        />
      </Grid>
      <Grid size="grow">
        <ModelAutocompleteField
          name='group'
          label={I18n.t('group.label', { count: 1 })}
          model_name='group'
          searchMode='search'
          searchQuery='startsWith'
          autocompleteMutator={autocompleteMutatorGroup}
          labelKeys={['label']}
          loadOnFocus={false}
          config={{ mutator: groupMutator }}
        />
      </Grid>
    </Grid>
  );
}

const Row3 = () =>
  <Grid container spacing={1}>
    <Grid size={'auto'}>
      <DateField name='createdAt_start' label={I18n.t('date.search')} inputFormat='DD/MM/YYYY' />
    </Grid>
    <Grid size={'auto'}>
      <DateField name='createdAt_end' label={I18n.t('prefix.to')} inputFormat='DD/MM/YYYY' />
    </Grid>
  </Grid>


const SearchForm = props => {
  const requestSubmit = hooks.useFormFunction('requestSubmit')
  const reset = hooks.useFormFunction('reset')
  return (
    <Box sx={{ borderRadius: 1, boxShadow: 6, display: 'flex', flexDirection: 'column', gap: 2, p: 3 }}>
      <Typography variant='h5'>{I18n.t('history.search')}</Typography>
      <Row1 />
      <Row2 />
      <Row3 />
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
        <Button onClick={requestSubmit} variant='contained' size='small'>{I18n.t('action.validate')}</Button>
        <Button onClick={reset} size='small'>{I18n.t('action.reset')}</Button>
      </Box>
    </Box>
  )
}

export default React.memo(SearchForm)
